import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkCreateTagsRequest = { tags: '_tag' };
var _bulkCreateTagsResponse = { results: '_bulkTagResult' };
var _bulkDeleteTagRequest = {};
var _bulkDeleteTagResponse = {};
var _bulkTagResult = { item: '_tag' };
var _createTagRequest = {};
var _createTagResponse = { tag: '_tag' };
var _deleteTagRequest = {};
var _deleteTagResponse = {};
var _getOrCreateTagRequest = {};
var _getOrCreateTagResponse = { tag: '_tag' };
var _getTagByLabelRequest = {};
var _getTagByLabelResponse = { tag: '_tag' };
var _getTagBySlugRequest = {};
var _getTagBySlugResponse = { tag: '_tag' };
var _getTagRequest = {};
var _getTagResponse = { tag: '_tag' };
var _getTagsCountByLanguageRequest = {};
var _getTagsCountByLanguageResponse = {};
var _listTagsRequest = {};
var _listTagsResponse = { tags: '_tag' };
var _queryTagsRequest = {};
var _queryTagsResponse = { tags: '_tag' };
var _tag = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _updateTagRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    tag: '_tag',
};
var _updateTagResponse = { tag: '_tag' };
function resolveComWixpressNpmCommunitiesPlatformizedBlogTagServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/communities-blog-node-api',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v2/stats',
                destPath: '/v2/stats',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v2/stats',
                destPath: '/v2/stats',
            },
        ],
        _: [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/blogs/this',
                destPath: '/_api/blogs/this',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/categories',
                destPath: '/_api/categories',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/site-properties',
                destPath: '/_api/site-properties',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/posts/content',
                destPath: '/_api/posts/content',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v2/stats',
                destPath: '/v2/stats',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'social-blog._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/blog/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/blog/v3',
                destPath: '/v3',
            },
            {
                srcPath: '/v2/stats',
                destPath: '/v2/stats',
            },
            {
                srcPath: '/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/blog/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/blog/v2/stats',
                destPath: '/v2/stats',
            },
            {
                srcPath: '/_api/v3/posts',
                destPath: '/v3/posts',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** If a tag already exists with the provided label, returns this tag. Otherwise, the request creates a new tag with the provided label. */
export function getOrCreateTag(payload) {
    var _a = serializer(_getOrCreateTagRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getOrCreateTagResponse, { _tag: _tag }).fromJSON;
    function __getOrCreateTag(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.tag',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.TagService.GetOrCreateTag',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogTagServiceUrl({
                protoPath: '/v2/tags',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getOrCreateTag.fromReq = fromReq;
    __getOrCreateTag.__isAmbassador = true;
    return __getOrCreateTag;
}
/** Creates a new tag with the provided label if a tag with the same label doesn't already exist. */
export function createTag(payload) {
    var _a = serializer(_createTagRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createTagResponse, { _tag: _tag }).fromJSON;
    function __createTag(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.tag',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.TagService.CreateTag',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogTagServiceUrl({
                protoPath: '/v3/tags',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createTag.fromReq = fromReq;
    __createTag.__isAmbassador = true;
    return __createTag;
}
/** Updates a tag. */
export function updateTag(payload) {
    var _a = serializer(_updateTagRequest, {
        _tag: _tag,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateTagResponse, { _tag: _tag }).fromJSON;
    function __updateTag(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.tag',
            method: 'PATCH',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.TagService.UpdateTag',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogTagServiceUrl({
                protoPath: '/v3/tags/{tag.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateTag.fromReq = fromReq;
    __updateTag.__isAmbassador = true;
    return __updateTag;
}
/** Creates multiple tags. */
export function bulkCreateTags(payload) {
    var _a = serializer(_bulkCreateTagsRequest, { _tag: _tag }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateTagsResponse, {
        _bulkTagResult: _bulkTagResult,
        _tag: _tag,
    }).fromJSON;
    function __bulkCreateTags(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.tag',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.TagService.BulkCreateTags',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogTagServiceUrl({
                protoPath: '/v3/bulk/tags/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateTags.fromReq = fromReq;
    __bulkCreateTags.__isAmbassador = true;
    return __bulkCreateTags;
}
/** Retrieves a count of tags for every site language. */
export function getTagsCountByLanguage(payload) {
    var _a = serializer(_getTagsCountByLanguageRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getTagsCountByLanguageResponse, {}).fromJSON;
    function __getTagsCountByLanguage(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.tag',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.TagService.GetTagsCountByLanguage',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogTagServiceUrl({
                protoPath: '/v3/tags/count-by-language',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getTagsCountByLanguage.fromReq = fromReq;
    __getTagsCountByLanguage.__isAmbassador = true;
    return __getTagsCountByLanguage;
}
/**
 * Gets a tag by the provided label.
 *
 * Sub-labels can also be specified using a `/`. For example, you can have `'dessert/icecream'` and `'dessert/pie'` as two different tag labels.
 *
 * > **Note**: The full URL path following `labels/` is counted as 1 label. Adding a `/` to a label does _not_ create multiple labels. This means that `'dessert/icecream'` is a single label.
 */
export function getTagByLabel(payload) {
    var _a = serializer(_getTagByLabelRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getTagByLabelResponse, { _tag: _tag }).fromJSON;
    function __getTagByLabel(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.tag',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.TagService.GetTagByLabel',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogTagServiceUrl({
                protoPath: '/v3/tags/labels/{label}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getTagByLabel.fromReq = fromReq;
    __getTagByLabel.__isAmbassador = true;
    return __getTagByLabel;
}
/** Gets a tag with the provided ID. */
export function getTag(payload) {
    var _a = serializer(_getTagRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getTagResponse, { _tag: _tag }).fromJSON;
    function __getTag(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.tag',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.TagService.GetTag',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogTagServiceUrl({
                protoPath: '/v3/tags/{tagId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getTag.fromReq = fromReq;
    __getTag.__isAmbassador = true;
    return __getTag;
}
/** Gets a tag with the provided slug. */
export function getTagBySlug(payload) {
    var _a = serializer(_getTagBySlugRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getTagBySlugResponse, { _tag: _tag }).fromJSON;
    function __getTagBySlug(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.tag',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.TagService.GetTagBySlug',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogTagServiceUrl({
                protoPath: '/v3/tags/slugs/{slug}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getTagBySlug.fromReq = fromReq;
    __getTagBySlug.__isAmbassador = true;
    return __getTagBySlug;
}
/**
 * Retrieves a list of up to 500 tags, given the provided paging, filtering, and sorting.
 *
 * Query Posts runs with these defaults, which you can override:
 * - `postCount` is sorted in `DESC` order.
 * - `paging.limit` is `50`.
 * - `paging.offset` is `0`.
 *
 * For field support for filters and sorting, see
 * [Field Support for Filtering and Sorting](https://dev.wix.com/docs/rest/business-solutions/blog/tags/filter-and-sort).
 *
 * To learn about working with _Query_ endpoints, see
 * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
 * [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/sorting-and-paging), and
 * [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 * For a detailed list of supported filters and sortable fields, see
 * [Field Support for Filtering and Sorting](https://dev.wix.com/docs/rest/business-solutions/blog/posts-stats/filter-and-sort).
 */
export function queryTags(payload) {
    var _a = serializer(_queryTagsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryTagsResponse, { _tag: _tag }).fromJSON;
    function __queryTags(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.tag',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.TagService.QueryTags',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogTagServiceUrl({
                protoPath: '/v3/tags/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryTags.fromReq = fromReq;
    __queryTags.__isAmbassador = true;
    return __queryTags;
}
/** Lists tags. Default sort is descending by post count and default tag size is 50. */
export function listTags(payload) {
    var _a = serializer(_listTagsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listTagsResponse, { _tag: _tag }).fromJSON;
    function __listTags(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.tag',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.TagService.ListTags',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogTagServiceUrl({
                protoPath: '/v3/tags',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData, true),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listTags.fromReq = fromReq;
    __listTags.__isAmbassador = true;
    return __listTags;
}
/** Bulk delete for tags */
export function bulkDeleteTag(payload) {
    var _a = serializer(_bulkDeleteTagRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteTagResponse, {}).fromJSON;
    function __bulkDeleteTag(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.tag',
            method: 'DELETE',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.TagService.BulkDeleteTag',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogTagServiceUrl({
                protoPath: '/v3/bulk/tag',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteTag.fromReq = fromReq;
    __bulkDeleteTag.__isAmbassador = true;
    return __bulkDeleteTag;
}
/** Deletes a tag. Deleting a tag removes that tag from all blog posts that contain it. */
export function deleteTag(payload) {
    var _a = serializer(_deleteTagRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteTagResponse, {}).fromJSON;
    function __deleteTag(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.tag',
            method: 'DELETE',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.TagService.DeleteTag',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogTagServiceUrl({
                protoPath: '/v3/tags/{tagId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteTag.fromReq = fromReq;
    __deleteTag.__isAmbassador = true;
    return __deleteTag;
}
//# sourceMappingURL=http.impl.js.map